import AdminHome from "../components/AdminHome";
import AddUser from "../contents/AddUser";
import Analytics from "../contents/Analytics";
import AddNotificationForm from "../contents/AddNotificationForm";
import ManageNotifications from "../contents/ManageNotifications";
import PromotionManagement from "../contents/PromotionManagement";
import BalanceManagement from "../contents/BalanceManagement";
import UserManagement from "../contents/UserManagement";
import ExemptPhoneNumbers from "../components/ExemptPhoneNumbers";
import LocationManagement from "../components/LocationManagement";
import CategoriesManagement from "../contents/CategoriesManagement";
import ChatManagement from "../components/ChatManagement";
import TariffsManagement from "../contents/TariffsManagement";
import AppVersionManagement from "../components/AppVersionManagement";
import MonitoringDashboard from "../components/MonitoringDashboard";
import MarketingHub from "../components/MarketingHub";
import OrdersManagement from "../contents/OrdersManagement";

/** Base path for all admin routes */
export const ADMIN_BASE = "/admin";

/** Default tab when opening /admin */
export const DEFAULT_ADMIN_TAB = "overview";

/**
 * Admin section routes: id (for a11y), path segment, label, icon component, page component.
 * `group` groups routes in the sidebar (Overview | Users & Ads | Marketing | Finance | System).
 */
export const ADMIN_ROUTES = [
  {
    id: "overview",
    path: "overview",
    label: "Обзор",
    icon: "home",
    group: "overview",
    Component: AdminHome,
  },
  {
    id: "add-user",
    path: "add-user",
    label: "Добавить пользователя",
    icon: "user",
    group: "users",
    Component: AddUser,
  },
  {
    id: "analytics",
    path: "analytics",
    label: "Аналитика",
    icon: "chart",
    group: "overview",
    Component: Analytics,
  },
  {
    id: "add-notification",
    path: "add-notification",
    label: "Добавить уведомление",
    icon: "bell",
    group: "marketing",
    Component: AddNotificationForm,
  },
  {
    id: "manage-notifications",
    path: "manage-notifications",
    label: "Управление уведомлениями",
    icon: "list",
    group: "marketing",
    Component: ManageNotifications,
  },
  {
    id: "promotion",
    path: "promotion",
    label: "VIP Продвижение",
    icon: "star",
    group: "marketing",
    Component: PromotionManagement,
  },
  {
    id: "balance",
    path: "balance",
    label: "Баланс",
    icon: "wallet",
    group: "finance",
    Component: BalanceManagement,
  },
  {
    id: "users",
    path: "users",
    label: "Пользователи",
    icon: "users",
    group: "users",
    Component: UserManagement,
  },
  {
    id: "orders",
    path: "orders",
    label: "Заказы и корзины",
    icon: "cart",
    group: "finance",
    Component: OrdersManagement,
  },
  {
    id: "exempt-phone-numbers",
    path: "exempt-phone-numbers",
    label: "Освобожденные номера",
    icon: "phone",
    group: "users",
    Component: ExemptPhoneNumbers,
  },
  {
    id: "location-management",
    path: "location-management",
    label: "Управление локациями",
    icon: "map",
    group: "system",
    Component: LocationManagement,
  },
  {
    id: "categories",
    path: "categories",
    label: "Категории",
    icon: "list",
    group: "system",
    Component: CategoriesManagement,
  },
  {
    id: "chat-management",
    path: "chat-management",
    label: "Управление чатами",
    icon: "message",
    group: "chat",
    Component: ChatManagement,
  },
  {
    id: "tariffs",
    path: "tariffs",
    label: "Тарифы",
    icon: "package",
    group: "finance",
    Component: TariffsManagement,
  },
  {
    id: "app-version-management",
    path: "app-version-management",
    label: "Управление версиями приложения",
    icon: "smartphone",
    group: "system",
    Component: AppVersionManagement,
  },
  {
    id: "monitoring-dashboard",
    path: "monitoring-dashboard",
    label: "Мониторинг панели",
    icon: "activity",
    group: "system",
    Component: MonitoringDashboard,
  },
  // === Маркетинг и баннеры — 4 разрозненных страницы объединены (tabs) ===
  // MarketingPostsManagement (новый оркестратор), SystemBannerManagement
  // (legacy activation), CompanyBannerModeration (модерация BUSINESS/DEALER
  // баннеров), StoriesManagement (legacy) — все под одним пунктом сайдбара.
  {
    id: "marketing-hub",
    path: "marketing-hub",
    label: "Маркетинг и баннеры",
    icon: "megaphone",
    group: "marketing",
    Component: MarketingHub,
  },
];

/** Get route config by path segment */
export function getAdminRouteByPath(pathSegment) {
  return ADMIN_ROUTES.find((r) => r.path === pathSegment) || null;
}

/** Get current section label for breadcrumb */
export function getAdminSectionLabel(pathSegment) {
  const route = getAdminRouteByPath(pathSegment);
  return route ? route.label : "Админ";
}
